import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "22",
  fill: "none",
  viewBox: "0 0 18 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13 15a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zm0-4a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zM7 7a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2zm5-1h2.586L12 3.414zm6 13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h8a1 1 0 0 1 .707.293l6 6A1 1 0 0 1 18 7zM2 19a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8h-5a1 1 0 0 1-1-1V2H3a1 1 0 0 0-1 1z"
    }, null, -1)
  ]))]))
}
export default { render: render }